import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { usePwaInstall } from "@/lib/pwa";
import { PWA_CONFIG, pwaRoleForPath } from "@/lib/manifest";
import { Button } from "@/components/ui/button";
import { Download, X, Share, PlusSquare } from "lucide-react";

const KEY = "sc_pwa_dismissed_at";

export const InstallPrompt = () => {
  const { canInstall, isIos, installed, install } = usePwaInstall();
  const { pathname } = useLocation();
  const role = pwaRoleForPath(pathname);
  const cfg = PWA_CONFIG[role];
  const btnCls = { admin: "bg-slate-900 hover:bg-slate-800", guru: "bg-teal-600 hover:bg-teal-700", murid: "bg-amber-500 hover:bg-amber-600", default: "bg-teal-600 hover:bg-teal-700" }[role];
  const dkey = `${KEY}_${role}`;
  const [hidden, setHidden] = useState(Number(localStorage.getItem(dkey) || 0) && Date.now() - Number(localStorage.getItem(dkey)) < 3 * 24 * 60 * 60 * 1000);
  const [busy, setBusy] = useState(false);

  if (hidden || installed || (!canInstall && !isIos)) return null;

  const dismiss = () => {
    localStorage.setItem(dkey, String(Date.now()));
    setHidden(true);
  };

  const doInstall = async () => {
    setBusy(true);
    const ok = await install();
    setBusy(false);
    if (ok) setHidden(true);
  };

  return (
    <div className="fixed inset-x-3 bottom-3 sm:inset-x-auto sm:right-5 sm:bottom-5 sm:w-[380px] z-[60] animate-pop" data-testid="pwa-install-banner">
      <div className="bg-white rounded-3xl shadow-2xl border border-teal-100 p-4 flex gap-3 items-start">
        <div className="w-14 h-14 rounded-2xl bg-slate-50 flex items-center justify-center shrink-0 overflow-hidden">
          <img src={cfg.icon} alt={cfg.label} className="w-full h-full object-cover rounded-2xl" data-testid="pwa-install-icon" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-display font-bold text-slate-800" data-testid="pwa-install-title">Instal {cfg.label}</p>
          {canInstall ? (
            <>
              <p className="text-xs text-slate-500 mt-0.5">Pasang di layar utama agar buka lebih cepat, layar penuh, dan bisa dipakai seperti aplikasi.</p>
              <div className="flex gap-2 mt-3">
                <Button size="sm" onClick={doInstall} disabled={busy} className={`rounded-xl flex-1 text-white ${btnCls}`} data-testid="pwa-install-btn">
                  <Download className="w-4 h-4 mr-1.5" /> Instal Sekarang
                </Button>
                <Button size="sm" variant="ghost" onClick={dismiss} className="rounded-xl text-slate-500" data-testid="pwa-install-later">Nanti</Button>
              </div>
            </>
          ) : (
            <p className="text-xs text-slate-600 mt-1 leading-relaxed" data-testid="pwa-ios-hint">
              Di iPhone/iPad: ketuk tombol <Share className="inline w-3.5 h-3.5 mx-0.5 -mt-0.5" /> <b>Bagikan</b> di Safari, lalu pilih <PlusSquare className="inline w-3.5 h-3.5 mx-0.5 -mt-0.5" /> <b>Tambah ke Layar Utama</b>.
            </p>
          )}
        </div>
        <button onClick={dismiss} className="p-1 rounded-lg hover:bg-slate-100 text-slate-400" aria-label="Tutup" data-testid="pwa-install-close"><X className="w-4 h-4" /></button>
      </div>
    </div>
  );
};

